import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  IconButton,
} from "@mui/material";
import { update_addon_info_detail } from "../../DAL/form/userForm";
import { useSnackbar } from "notistack";
import CloseIcon from "@mui/icons-material/Close";

const UpdateAddonDialog = ({
  open,
  onClose,
  getDetail,
  initialData,
  addon_id,
}) => {
  console.log("addon_Id", addon_id);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    relationship: "",
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        first_name: initialData.first_name || "",
        last_name: initialData.last_name || "",
        email: initialData.email || "",
        relationship: initialData.relationship || "",
      });
    }
  }, [initialData, open]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleUpdateAddon = async (e) => {
    e.preventDefault();
    setLoading(true);

    const postData = {
      addon_form_id: addon_id,
      addon_info: {
        first_name: formData.first_name,
        last_name: formData.last_name,
        email: formData.email,
        relationship: formData.relationship,
      },
    };

    const result = await update_addon_info_detail(postData);

    if (result.code === 200) {
      enqueueSnackbar("Add-on updated successfully", { variant: "success" });
      onClose();
      if (getDetail) {
        getDetail();
      }
    } else {
      enqueueSnackbar(result?.message || "Failed to update add-on", {
        variant: "error",
      });
    }
    setLoading(false);
  };

  return (
    <Dialog
      open={open}
      onClose={!loading ? onClose : undefined}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "12px",
        },
      }}
    >
      <form onSubmit={handleUpdateAddon}>
        <DialogTitle
          sx={{
            p: "12px 24px",
            borderBottom: "1px solid #dee2e6",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3 className="mb-0">Edit Add-on</h3>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent className="pt-3" sx={{ p: 3 }}>
          <TextField
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            fullWidth
            margin="normal"
            variant="outlined"
            required
          />
          <TextField
            label="First Name"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            fullWidth
            margin="normal"
            variant="outlined"
            required
          />
          <TextField
            label="Last Name"
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
            fullWidth
            margin="normal"
            variant="outlined"
            required
          />
          <TextField
            label="Relationship"
            name="relationship"
            value={formData.relationship}
            onChange={handleChange}
            fullWidth
            margin="normal"
            variant="outlined"
            placeholder="e.g. Spouse"
            required
          />
        </DialogContent>

        <DialogActions sx={{ p: "12px 24px", borderTop: "1px solid #dee2e6" }}>
          <Button variant="outlined" onClick={onClose} disabled={loading}>
            Close
          </Button>
          <Button
            variant="contained"
            type="submit"
            disabled={loading}
            sx={{
              backgroundColor: "#15978a",
              "&:hover": { backgroundColor: "#0d6b61" },
              minWidth: "120px",
            }}
          >
            {loading ? (
              <CircularProgress size={24} sx={{ color: "white" }} />
            ) : (
              "Update Add-on"
            )}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default UpdateAddonDialog;
